<template>
  <v-autocomplete
    :label="label"
    v-model="model"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    item-text="display"
    item-value="code"
    placeholder="Start typing..."
  ></v-autocomplete>
</template>

<script>
import { fetchResource } from "@/api/fhir";

export default {
  props: {
    label: String,
    valueSetId: String,
    codeSystemId: { default: undefined, type: String },
    value: String
  },
  data() {
    return {
      items: [],
      search: null,
      loading: false,
      model: null
    };
  },
  computed: {
    isCodeSystem() {
      return this.codeSystemId;
    },
    id() {
      return this.codeSystemId ? this.codeSystemId : this.valueSetId;
    }
  },
  watch: {
    value(val) {
      this.model = val;
    },
    model(val) {
      this.$emit("input", val);
    }
    // async search(val) {
    //   // Items have already been loaded
    //   if (this.items.length > 0) return;
    //
    //   // Items have already been requested
    //   if (this.loading) return;
    //
    //   this.loading = true;
    //
    //   // Lazily load input items
    //   this.items = await this.method(this.token);
    //   this.loading = false;
    // }
  },
  async mounted() {
    let resourceType = "ValueSet";
    if (this.isCodeSystem) resourceType = "CodeSystem";
    const valueSet = await fetchResource(`${resourceType}/${this.id}`);
    if (this.isCodeSystem) {
      this.items = valueSet.concept;
    } else {
      // add all concepts from different includes
      for (let include of valueSet.compose.include) {
        include.concept.forEach(e => this.items.push(e));
      }
    }
  }
};
</script>

<style scoped></style>
